var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import authentication from "@irati/auth";
import { injectIntl } from "@irati/utils/lang";
import medicalTracking from "@irati-tracking/medical";
import { IFrameWrapper, IFrame } from "./styled";
var Video = /** @class */ (function (_super) {
    __extends(Video, _super);
    function Video(props) {
        var _this = _super.call(this, props) || this;
        _this.getHighestTier = function () {
            if (authentication.apps("medical.tiers.tier3")) {
                return 3;
            }
            else if (authentication.apps("medical.tiers.tier2")) {
                return 2;
            }
            return 1;
        };
        _this.onMessageReceived = function (e) {
            if (e.origin === "https://player.vimeo.com") {
                var data = JSON.parse(e.data);
                if (data.event === "ready") {
                    var postData = { method: "addEventListener", value: "play" };
                    _this.video.current.contentWindow.postMessage(JSON.stringify(postData), _this.video.current.src);
                }
                else if (data.event === "play") {
                    var hasVideoTrackingEventFired = _this.state.hasVideoTrackingEventFired;
                    if (!hasVideoTrackingEventFired) {
                        _this.setState({ hasVideoTrackingEventFired: true });
                        medicalTracking.viewVideo(_this.getHighestTier());
                    }
                }
            }
        };
        _this.state = {
            hasVideoTrackingEventFired: false
        };
        _this.video = React.createRef();
        return _this;
    }
    Video.prototype.componentDidMount = function () {
        window.addEventListener("message", this.onMessageReceived, false);
    };
    Video.prototype.componentWillUnmount = function () {
        window.removeEventListener("message", this.onMessageReceived, false);
    };
    Video.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        var hasTier2Access = authentication.apps("medical.tiers.tier2");
        return (React.createElement(IFrameWrapper, null,
            React.createElement(IFrame, { ref: this.video, frameBorder: "0", allowFullScreen: true, mozallowfullscreen: true, webkitAllowFullScreen: true, title: "MedicalVideo", src: formatMessage({ id: hasTier2Access ? "medical.landing.video.tier2" : "medical.landing.video.tier1" }) })));
    };
    return Video;
}(Component));
export default injectIntl(Video);
